// Cart order-summary trust badges (sections/main-cart-footer.liquid) - each
// row is a plain toggle button that opens its heading/content in a single
// shared gift-option-drawer (see gift-option-drawer.js, also used by the
// PDP's engraving/gift-wrap popups) instead of expanding inline.
class TrustBadges extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector('[data-trust-badge-modal]');
    this.overlay = this.querySelector('[data-trust-badge-overlay]');
    // Not `this.title` - HTMLElement already has a native `title` property
    // (the tooltip attribute), which silently stringifies whatever's
    // assigned to it instead of holding onto the element reference.
    this.titleElement = this.modal ? this.modal.querySelector('[data-trust-badge-title]') : null;
    this.body = this.modal ? this.modal.querySelector('[data-trust-badge-body]') : null;

    if (!this.modal) return;

    // Query close triggers (the header's [x] button plus the overlay, both
    // marked data-trust-badge-close) before relocating - relocateDrawer
    // moves the modal/overlay out to <body>, so afterwards they're no
    // longer descendants of `this` and this.querySelectorAll would find
    // nothing to attach the close handler to.
    const closeElements = this.querySelectorAll('[data-trust-badge-close]');

    this.relocateDrawer(this.modal, this.overlay);

    this.querySelectorAll('[data-trust-badge-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => this.open(toggle));
    });

    closeElements.forEach((element) => {
      element.addEventListener('click', () => this.close());
    });
  }

  open(toggle) {
    if (this.titleElement) this.titleElement.textContent = toggle.dataset.trustBadgeHeading || '';

    const contentTemplate = toggle.querySelector('[data-trust-badge-content]');
    if (this.body) this.body.replaceChildren(contentTemplate ? contentTemplate.content.cloneNode(true) : '');

    this.modal.show(toggle, toggle);
  }

  close() {
    if (this.modal) this.modal.hide();
  }

  // Same fixed-position relocation trick as gift-options.js's drawers - see
  // that file for why.
  relocateDrawer(drawer, overlay) {
    if (!drawer || drawer.parentElement === document.body) return;
    document.body.appendChild(drawer);
    if (overlay) drawer.after(overlay);
  }
}

if (!customElements.get('trust-badges')) {
  customElements.define('trust-badges', TrustBadges);
}
